function getQueryParams() {
  const urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;

  return {
    clickId: urlParams ? urlParams.get("click_id") : null,
    campaignId: urlParams ? urlParams.get("campaign_id") : null,
    code: urlParams ? urlParams.get("code") : null,
    variant: urlParams ? urlParams.get("variant") : null,
    info: urlParams ? urlParams.get("info") : null,
  };
}

function hasQueryParams() {
  let queryParams = getQueryParams();
  return queryParams.clickId && queryParams.campaignId && queryParams.code && queryParams.variant;
}

function getLocalQueryParams(){
  try {
    if (typeof localStorage !== "undefined") {
      return JSON.parse(localStorage.getItem("queryParams"));
    }
  }
  catch (error) {
    return error?.message
  }
}

function hasInfoQueryParams() {
  let queryParams = getQueryParams();
  return queryParams.info;
}

export {
  getQueryParams,
  hasQueryParams,
  hasInfoQueryParams,
  getLocalQueryParams,
}
